import { render, staticRenderFns } from "./app/app.html?vue&type=template&id=4df56a3b&scoped=true&external"
import script from "./app/app.js?vue&type=script&lang=js&external"
export * from "./app/app.js?vue&type=script&lang=js&external"
import style0 from "./app/app.css?vue&type=style&index=0&id=4df56a3b&prod&scoped=true&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=4df56a3b&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df56a3b",
  null
  
)

export default component.exports